import React from 'react';
import { Element, scroller } from 'react-scroll';
import { Pagination, Icon } from 'antd';
import { compose, withProps } from 'recompose';
import styled from 'styled-components';

import ProductItem from './ProductItem';

const ProductPagination = styled(Pagination)`
  display: flex;
  justify-content: flex-end;
  padding: 0 25px !important;
`;

const Container = styled.div`
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  padding: 0px 25px;
  position: relative;
`;

const CardContainer = styled.div`
  width: 23.5%;
  margin-bottom: 16px;
  &:nth-child(4n - 3) {
    margin-right: 1%;
  }
  &:nth-child(4n - 2), &:nth-child(4n - 1) {
    margin-left: 1%;
    margin-right: 1%;
  }
  &:nth-child(4n) {
    margin-left: 1%;
  }
  @media(max-width: 600px) {
    width: 100%;
    margin: 0;
    margin-bottom: 16px;
  }
`;

const enhance = compose(
  withProps(
    props => ({
      onChange: (page, pageSize) => {
        props.onPaginate(page, pageSize);
        scroller.scrollTo('card', {
          smooth: true
        });
      }
    })
  )
);

const LoaderContainer = styled.div`
  position: absolute;
  left: 0;
  right: 0;
  bottom: 0;
  top: 0;
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: rgba(255, 255, 255, 0.9);
  flex-direction: column;
`;

const LoadingIcon = styled(Icon)`
  font-size: 32px;
  margin-bottom: 16px;
`;

const LoadingText = styled.p`
  font-size: 16px;
`;

const ProductList = props => {
  const { products, onSelect, rate, allCount, loading, currentPage, localWishlists, wishlistFn, noPaginate } = props;
  return (
    <Element name="card">
      <Container>
        {products.map(product => {
          const isInWishlist = !!localWishlists[product._id];
          return (
            <CardContainer>
              <ProductItem
                isInWishlist={isInWishlist}
                rate={rate}
                item={product}
                onSelect={() => onSelect(product)}
                onToggleWishlist={() => {
                  if (isInWishlist) {
                    wishlistFn.remove(product._id);
                  } else {
                    wishlistFn.add(product._id);
                  }
                }}
              />
            </CardContainer>
          );
        })}
        {loading && (
          <LoaderContainer>
            <LoadingIcon type="loading" />
            <LoadingText>Loading</LoadingText>
          </LoaderContainer>
        )}
      </Container>
      {!noPaginate && (
        <ProductPagination
          size="small"
          current={currentPage}
          pageSize={12}
          total={allCount}
          onChange={props.onChange}
        />
      )}
    </Element>
  );
};

export default enhance(ProductList);



// WEBPACK FOOTER //
// ./src/components/Product/ProductList.js